/** @format */

export const featureFlagNames = [
    'BEAK-2867-(model-recommendations)',
    'LOVE-360-(FAQ-section-update)',
    'BOO-3170-(sell-balance)',
    'LOVE-389-(new-checkout-buy)',
    'LOVE-389-(new-checkout-payment-link)',
    'LOVE-747-(enhanced-product-protection)',
    'BEAK-3193-(oos-model-recommendations)',
    'BEAK-3098-(auto-out-of-stock-search)',
    'TUR-2946-(humanised-filters)',
    'BEAK-3192-(oos-search-model-recommendations)',
] as const;

export enum RecommendationsVariant {
    CONTROL = 'control',
    VARIANT = 'variant',
}
